<template>
    <div>
        <v-row v-for="(n, index) in numContacts" :key="index">
            <v-col cols="12" md="6">
                <p>Contact Name</p>
                <v-text-field 
                    outlined 
                    dense 
                    :error-messages="nameErrors"
                    v-model="contact.contactName"
                    @input="() => {
                        $v.contact.contactName.$touch()
                        checkValid()
                    }"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <p>Main Phone Number</p>
                <v-text-field 
                            outlined
                            dense                             
                            placeholder="(999) 999-9999"
                            :error-messages="phoneNumberErrors"
                            v-model="contact.mainPhone"
                            @input="() => {
                                $v.contact.mainPhone.$touch()
                                checkValid()
                            }"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <p>Email</p>
                <v-text-field
                    outlined
                    dense
                    :error-messages="emailErrors"
                    v-model="contact.email"
                    @input="() => {
                        $v.contact.email.$touch()
                        checkValid()
                    }"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
                <p>Mobile Phone Number</p>
                <v-text-field 
                            outlined 
                            placeholder="(999) 999-9999"
                            dense     
                            v-model="contact.mobilePhone"
                            @input="() => {
                                checkValid()
                            }"
                ></v-text-field>
            </v-col>
            <!-- <v-col v-if="index === numContacts - 1 && numContacts < maxContacts" cols="12" md="1" class="mt-md-6">
                <v-btn dense color="primary">
                    <v-icon color="white" @click="() => { numContacts++ }">mdi-plus</v-icon>
                </v-btn>
            </v-col>
            <v-col v-if="(index === numContacts - 1 && numContacts >= maxContacts) || index !== 0 " cols="12" md="1" class="mt-md-6">
                <v-btn dense color="primary">
                    <v-icon color="white" @click="() => { numContacts = numContacts - 1 }">mdi-close</v-icon>
                </v-btn>
            </v-col> -->
        </v-row>
    </div>
</template>

<script>
    import { required, email} from 'vuelidate/lib/validators'
import { formatPhoneNumber } from '../../utils/utils'
    export default {
        name: "ContactInformation",
        data() {
            return {
                numContacts: 1,
                maxContacts: 3,
                contact: {},
            }
        },
        validations: {
            contact: {
                contactName: { required },
                mainPhone: {required}, 
                mobilePhone: {},               
                email: {required, email},
            }
        },
        methods: {
            checkValid() {
                this.contact.mainPhone = formatPhoneNumber(this.contact.mainPhone)
                this.contact.mobilePhone = formatPhoneNumber(this.contact.mobilePhone)
                if(this.$v.contact.$invalid) {
                    this.$store.commit('setValidInputs', false)
                } else {
                    this.$store.commit('setValidInputs', true)
                    this.$store.commit('setContacts', this.contact)
                }
            },
        },
        computed: {
            nameErrors () {
                const errors = []
                if (!this.$v.contact.contactName.$dirty) return errors
                !this.$v.contact.contactName.required && errors.push('Contact name is required')
                return errors
            },
            emailErrors () {
                const errors = []
                if (!this.$v.contact.email.$dirty) return errors
                !this.$v.contact.email.email && errors.push('A valid email is required')
                !this.$v.contact.email.required && errors.push('Referral Email is required')
                return errors
            },
            phoneNumberErrors () {
                const errors = []
                if (!this.$v.contact.mainPhone.$dirty) return errors
                !this.$v.contact.mainPhone.required && errors.push('Phone Number is required')
                return errors
            },
        },
        beforeMount () {
            this.$store.commit('setValidInputs', false);
        },
    }
</script>

<style lang="scss" scoped>

</style>